import { render, staticRenderFns } from "./NotificationJIRequestModal.vue?vue&type=template&id=ec1ef72a&scoped=true"
import script from "./NotificationJIRequestModal.vue?vue&type=script&lang=js"
export * from "./NotificationJIRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1ef72a",
  null
  
)

export default component.exports